import styled, { css } from 'styled-components';
import { elevation } from '@legacy-vfuk/core-mixins';

export const BlockWrapper = styled.div`
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  [class^='Blockstyle__Block-sc'] {
    padding: 32px 16px;

    @media (min-width: 768px) {
      padding: 48px 20px 36px 20px;
      width: 100%;
    }

    [class^='Blockstyle__ContentWrapper-sc'] {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1280px;
    }
  }
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;


export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 794px) {
    margin-right: 0px;
    margin-left: 0px;
  }
`;

export const ArticlesWrapper = styled.div`
  display: grid;
  grid-template-areas:
    "featured latest sixth"
    "most-popular latest sixth"
    "media recently-viewed recently-viewed";
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 20px;
  width: 100%;
  height: 100%;

  [class^='Headingstyle__Heading-sc'] {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }

  @media (max-width: 768px) {
    grid-template-areas:
      "featured"
      "latest"
      "sixth"
      "most-popular"
      "media"
      "recently-viewed";
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const FeaturedCard = styled.div`
  grid-area: featured;
  height: 255px;
  border-radius: 8px;

  @media (max-width: 768px) {
    height: 230px;
  }
  
`;

export const LatestCard = styled.div`
  grid-area: latest;
  height: 530px;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    height: 230px;
  }
`;

export const MostPopularCard = styled.div`
  grid-area: most-popular;
  height: 255px;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    height: 230px;
  }
`;

export const MediaCard = styled.div`
  grid-area: media;
  height: 255px;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    height: 230px;
  }
`;

export const RecentlyViewedCard = styled.div`
  grid-area: recently-viewed;
  height: 255px;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    height: 230px;
  }
`;

export const SixthCard = styled.div`
  grid-area: sixth;
  height: 530px;
  border-radius: 8px;
  
  
  @media (max-width: 768px) {
    height: 100%;
  }
`;

export const TopicPreferencesCard = styled.a`
  text-decoration: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: #FFFFFF;
  background-color: #262626;
  border-radius: 6px;
  padding: 30px 20px;
  cursor: pointer;
  ${elevation(true)}
  
  @media only screen and (min-width: 1151px) {
    transition: all 0.2s ease-in-out;
    :hover {
      transform: scale(1.05);
    }
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const TopicWrapper = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const Topic = styled.div`
  display: flex;
  padding: 12px 18px;
  border-radius: 6px;
  background-color: #313131;
  margin-bottom: 8px;
  align-items: center;

  svg {
    height: 32px;
    width: 32px;
  }

  @media (max-width: 768px) {
    padding: 6px 9px;
    width: 48%;
    margin-bottom: 0px;
  }
`;

export const TopicText = styled.div`
  margin-left: 8px;
`;

export const TopicTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  svg {
    height: 64px;
    width: 64px;

    @media (max-width: 768px) {
      height: 40px;
      width: 40px;
    }
  }

  h3 {
    font-size: 26px;
    line-height: 28px;
    font-weight: 700;
    margin-top: 12px;

    @media (max-width: 768px) {
      margin-top: 8px;
      margin-bottom: 8px;
      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
    }
  }
`;

export const TopicButtonWrapper = styled.div`
  width: 100%;

  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    width: 100%;
    a {
      width: 100%;
    }
  }
`;


export const ButtonRowWrapper = styled.div`
  margin-top: 20px;

  .button {
    padding-left: 0px;
  }
`;
